module.exports = __webpack_public_path__ + "img/view-reports-blue.064a5b40.svg";